import { useState } from "react"

export default function PaymentFail() {
    return <>
        <div className="px-[20px] lg:px-[80px] pt-28">
            پرداخت با با خطا مواجه شد
        </div>
    </>
}